export const AGENT_PRIVILEGES = {
  READ_WRITE_FILES: 1,
  READ_ONLY_GITLAB: 2,
  READ_WRITE_GITLAB: 3,
  RUN_COMMANDS: 4,
  USE_GIT: 5,
  RUN_MCP_TOOLS: 6,
};
